<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { onMounted } from 'vue'
import { Head } from '@inertiajs/inertia-vue3'
import usePref from '@/Shared/usePref.js'
import Icon from '@/Shared/Icons/Icon'

const brands = [
  {
    id: 'darntough',
    name: 'ダーンタフ',
    url: 'https://www.darntough.jp/about/ourguarantee/',
    logo: 'logo_darntough.svg',
    content: `
<p>DARN TOUGH VERMONT製品は、全て生涯保証となっております。アウトドアソックスでは例がありません。<br/>そのうたい文句もシンプルで、"私たちのソックスは、お客さまにとって快適で耐久性のあるものである事を自負しています。 </p>
<p><strong>保証内容</strong><br/>通常のご使用で穴があいた場合は商品を無償（同等モデルの場合）で交換いたします。</p>
    `,
  },
  {
    id: 'sabbatical',
    name: 'サバティカル',
    url: 'https://sabbatical.jp/faq',
    logo: 'logo_sabbatical.svg',
    content: `
<p>SABBATICAL（サバティカル）製品の保証については初期不良に対してのみ保証を設けております。 お買い求め頂きました製品は数々のテストと検査をした後に販売しておりますが、万一不備がございましたら、カスタマーサービスにご連絡ください。 製造上の欠陥による不具合の場合は無償で修理または交換をさせていただきます。なお、修理、交換などの要否につきましては、弊社の裁量にてご判断させていただきます。</p>
<div>
  <p>なお、以下のような原因での破損などにつきましては保証いたしませんのでご了承ください。</p>
  <ul>
    <li>本製品の誤った使用方法によるもの</li>
    <li>間違ったお手入れ、保管方法、経年変化やUVによる素材劣化によるもの</li>
    <li>その他、製造上の欠陥以外の原因によるもの</li>
    <li>注意タグが製品についていない場合</li>
    <li>初期不良に気付いてから、一定期間が経過してからご連絡を頂いたもの。その後、数回使用されたもの（※初期不良が発覚した場合には、すぐにご連絡ください。）</li>
  </ul>
</div>
    `,
  },
  {
    id: 'mysteryranch',
    name: 'ミステリーランチ',
    url: 'https://www.mysteryranch.jp/warranty',
    logo: 'logo_mysteryranch.svg',
    content: `
<p>ミステリーランチは遂行すべき活動を支えるパックをデザイン・製造しています。ミッションを終えて無事に帰るために当ブランドのパックを信頼するユーザーへのサポートとして、製造上および材質のあらゆる欠陥に対する生涯保証を設けています。</p>
<p>ミステリーランチは製品の実用寿命にわたりパックの品質を保証し、欠陥に対して修理または交換を無料で行います。また万が一、パックが動物に襲われた、車で何キロも引きずってしまった、などによるダメージが生じた場合でも、できる限りの修理を有償にてうけたまわります。</p>
<p>ただし、保証対象外の修理の費用が新品の価格を超える場合は、修理を依頼されるよりも新たにパックを買い直すことをお勧めします。また、修理ができない場合もございます。</p>
    `,
  },
  {
    id: 'kleankanteen',
    name: 'クリーンカンティーン',
    url: 'https://www.kleankanteen.jp/pages/warranty',
    logo: 'logo_kleankanteen_2019.svg',
    content: `
<p>Klean Kanteen(クリーンカンティーン)が製造しているクリーンカンティーンボトルとアクセサリーには製品の初期不良に対しご購入日より1年間の保証を設けております。　経年劣化、傷やへこみ等の使用中の破損に関しては保証対象外ですのでご了承ください。その他クリーンカンティーン社製品以外のクリーンカンティーンアクセサリー、社外製品を利用して起きた不具合等も保証対象外となります。 お客様がお持ちのクリーンカンティーンボトルで下記のような症状が現れる場合、初期不良の可能性がございます。</p>
<p><strong>■小さな穴からの漏れ</strong><br> クリーンカンティーンボトルは1つ1つが手作りです。ごく稀ではありますが溶接部分に小さな穴ができ、それが漏れに繋がってしまう恐れがあります。　こういった症状に対しては初期不良としてクリーンカンティーンボトルが設けている保証対象になります。購入時にすでに傷やへこみなどがあった場合についても交換をさせていただきます。</p>
<p><strong>■溶接箇所の不具合</strong><br>ボトルの溶接箇所と表面は全て磨き上げていますが、もしもお持ちのクリーンカンティーンボトルの溶接箇所が起伏してしまっている場合は保証対象となります。</p>
<p><strong>■塗装の剥離</strong><br> クリーンカンティーンボトルを使用していく過程で擦り傷や衝撃により塗装の剥離が起こる場合があります。こういった場合の塗装剥離については保証対象外ですが、使用前に500円硬貨以上の大きさで簡単に塗装剥離が起こった場合は保証対象となります。</p>
<p><strong>■底部の変形</strong><br> ボトル底部の変形や膨らみは大抵の場合、液体を入れたボトルを冷凍することにより起こってしまいます。もしくはボトルを過熱したり過度な圧力を掛けたりすることで変形する恐れがありますが、こういった理由での保証は対象外となります。クリーンカンティーンボトルは冷凍したり、熱したりすることができる様な設計はされておりません。</p>
<p>もしも現在お持ちの製品に問題が生じ、それが初期不良なのか不明な場合は、サイト内の「よくあるお問い合わせ」ページをご参照の上、正しい方法でボトルを使用しているかをご確認ください。</p>
<p>初期不良と判断できる場合、不具合がある場合には、まずはご購入店へお問い合わせください。ご購入店にお問い合わせできない場合には、「お問い合わせ」ボタンをクリックしてください。保証請求を行う場合下記の情報を頂くことで、よりスムーズにプロセスを進めさせていただくことが出来ます。</p>
    `,
  },
  {
    id: 'barebones',
    name: 'ベアボーンズ',
    url: 'https://barebonesliving.jp/warranty/',
    logo: 'logo_Barebones_2019.svg',
    content: `
<p>Barebonesまたは正規のBarebones販売代理店から直接購入された製品は、2年間の限定保証または限定生涯保証のいずれかが適用されます。各製品の保証情報は、それぞれの製品ページ内の「保証」欄に記載されています。Barebones以外のサードパーティ製品（Barebonesが製造していない製品）は、以下に記載されている保証の対象外です。サードパーティ製品の保証については、該当メーカーまたは販売元にお問い合わせください。</p>
<p><strong>■2年間の限定保証</strong><br>この保証は、通常の使用環境で適切に製品をケア・メンテナンスした場合における、素材および製造上の欠陥を対象としています。Barebonesは、欠陥が認められた部品または製品について、交換品または同等の価値のある製品を提供します。</p>
<div>
  <p>以下の場合、この保証は無効となります：</p>
  <ul>
    <li>製品が取扱説明書に従って使用、組み立て、または操作されていない場合</li>
    <li>製品が第三者に転売または譲渡された場合</li>
    <li>製品に非対応の部品やアクセサリーが使用された場合</li>
    <li>ユーザーによる乱用や適切なメンテナンスの怠りがある場合</li>
  </ul>
  <small>※この保証は、購入日から2年を経過すると無効になります。</small>
</div>
<p><strong>■限定生涯保証</strong><br>この保証も、通常の使用環境で適切に製品をケア・メンテナンスした場合における、素材および製造上の欠陥を対象としています。Barebonesは、欠陥が認められた部品または製品について、交換品または同等の価値のある製品を提供します。</p>
<div>
  <p>以下の場合、この保証は無効となります：</p>
  <ul>
    <li>製品が取扱説明書に従って使用、組み立て、または操作されていない場合</li>
    <li>製品が第三者に転売または譲渡された場合</li>
    <li>製品に非対応の部品やアクセサリーが使用された場合</li>
    <li>ユーザーによる乱用や適切なメンテナンスの怠りがある場合</li>
  </ul>
  <small>※保証請求を処理する際には、購入証明書の提示を求められる場合があります。</small>
</div>
    `,
  },
  {
    id: 'eaglecreek',
    name: 'イーグルクリーク',
    url: 'https://www.eaglecreek.jp/faq/',
    logo: 'logo_eaglecreek_03.svg',
    content: `
<p>イーグルクリーク製品は、正規販売店からご購入されたお客様を対象に、下記の内容に沿って保証・修理対応をお受けしております。</p>
<div>
  <strong>■保証対象</strong>
    <ul>
      <li>材質及び、製造上の欠陥に関してイーグルクリークが定めたレギュレーションのもとに生涯保証が認められる場合。</li>
      <li>製品ご購入後、使用前に欠陥が判明した場合。</li>
      <li>航空会社による輸送中の破損などの場合は適用されませんのでご了承ください。</li>
      <li>手荷物として預けた荷物を受け取り次第破損していないかを確認していただき、故障が見受けられた際は航空会社または保険会社等へご連絡ください。</li>
    </ul>
    <small>※詳しくは、お問い合わせください。</small>
</div>
<p><strong>■修理対象</strong><br>日本国内での展開があり、修理パーツの供給があるもの。</p>
<div>
  <strong>■対応方法</strong>
  <ul>
    <li>修理品のモデル名、全体画像、修理個所が分かる画像を添付頂き、お問い合わせフォームよりお問い合わせください。</li>
    <li>修理内容により無償もしくは有償および、金額・納期が異なります。</li>
    <li>経年劣化、誤ったケアや過失などによるダメージに関しても可能な限りの修理を有償で行っております。</li>
    <li>修理品を弊社宛てに配送される場合の送料はお客様負担となりますのでご了承ください。</li>
  </ul>
  <small>※なお製造販売終了した製品、修理パーツの供給が終了した製品、経年劣化によるウレタンコーティングの剥がれ等、 製品によっては修理できない場合がございますので、あらかじめご了承ください。ウレタンコーティングは再コーティングが出来ない為、修理を承る事が出来ません。</small>
</div>
    `,
  },
  {
    id: 'maglite',
    name: 'マグライト',
    url: 'https://www.maglite.ne.jp/contact/index.html?brand=mag_lite',
    logo: 'logo_mag_lite.svg',
    content: `
<p>マグライトシリーズは10年限定保証を設けております。但し保証に関して免責事項がございます。</p>
<div>
  <p>具体的な免責事項は以下の通りです。</p>
  <ul>
    <li>電池の寿命</li>
    <li>電池の液漏れ、膨張</li>
    <li>白熱球の焼き切れ、LEDモジュールの熱損やLEDモジュールの損傷</li>
    <li>改造や誤用、メンテナンス不足による破損や欠陥</li>
    <li>消耗パーツの損傷</li>
  </ul>
</div>
    `,
  },
  {
    id: 'hala',
    name: 'ハラ',
    url: null,
    logo: 'logo_hala.svg',
    content: `
<p>お客様の購入された製品が長年に渡り、高い信頼性の下でご使用を頂けるように当社は製品の構造と品質にこだわり、材料や品質の欠陥に対して業界をリードする保証を提供しています。</p>
<p>お使いのHALAボードには、ご購入日から5年間、製品において瑕疵がないことをファーストオーナーに対して保証します。</p>
<p>商用としての保証は購入日から１年間、製品において瑕疵がないことをファーストオーナーに対して保証します。</p>
<p>パドルは、商用、個人に関わらず、購入日から1年間製品において瑕疵がないことを最初に購入されたファーストオーナーに対し保証します。万が一装備に欠陥が認められた場合には、弊社の判断で修理、交換、返金を行います。この保証は限定的であり、利用者の悪用または誤った使用によるもの、もしくは保証外で問題が発生した場合には保証の限りではありません。</p>
    `,
  },
]

const props = defineProps({
  pref: Object,
})

onMounted(() => {
  usePref(props.pref)  
})
</script>

<template>
  
  <div class="about warranty">
    <Head title="保証について" />
    <h2 class="page-title text-afgreen">
      warranty
      <small>保証について</small>
    </h2>
    <div class="m-auto sm:max-w-[840px] pb-[60px] sm:pb-[80px] md:pb-[100px] lg:pb-[120px]">

      <div class="px-[calc(5vw_+_10px)] lg:px-0">
        <p class="text-center text-[3.5vw] xs:text-[14px] sm:text-[15px] md:text-[16px] leading-[2.6] font-semibold mb-[50px] sm:mb-[60px] md:mb-[70px] lg:mb-[80px] break-keep">
          弊社直営店および弊社オンラインストア、<wbr />他、正規販売店にてご購入いただいた方のみ<wbr />適用される保証となります。<br>
          各ブランドごとに保証内容が異なります。<wbr />以下、各ブランドの保証をご確認ください。
        </p>
        
        <ul class="brands grid grid-cols-3 sm:grid-cols-4 items-center gap-[clamp(0.75rem,calc(0rem_+_2vw),1.5rem)] mb-[clamp(5rem,_calc(0rem_+_13.333vw),_10rem)]">
          <li v-for="brand in brands" :key="brand.id">
            <a :href="'#'+brand.id" class="aspect-square bg-white rounded-2xl flex justify-center items-center overflow-hidden p-[clamp(1rem,_calc(0rem_+_2.667vw),_2rem)]">
              <img :src="'https://img.aandf.co.jp/aandfcojp/img/brands/'+brand.logo" :alt="brand.name" class="max-h-20 "/>
            </a>
          </li>
        </ul>
      </div>
      
      <div class="md:px-[calc(5vw_+_10px)] lg:px-0">
        <ul class="flex flex-col gap-20 xs:gap-24 sm:gap-28 md:gap-32 lg:gap-36">
          <li v-for="brand in brands" :key="brand.id" :id="brand.id" class="flex flex-col gap-12 scroll-mt-[55px] md:scroll-mt-20">
            <img :src="'/img/warranty/'+brand.id+'.png'" :alt="brand.name" class="md:rounded-2xl"/>
            <div class="flex flex-col sm:items-start gap-6 md:gap-8 px-[calc(5vw_+_10px)] md:px-0">
              <h3 class="text-[17px] xs:text-[18px] sm:text-[19px] lg:text-[20px] font-bold leading-none tracking-wide">{{ brand.name }}の保証</h3>
              <div class="flex flex-col gap-6 md:gap-8 text-[13px] sm:text-[14px] lg:text-[15px] leading-[2.4] [&_ul]:list-disc [&_ul]:pl-4 [&_small]:block [&_small]:leading-[1.8] [&_small]:mt-2" v-html="brand.content" />
              <a v-show="brand.url" class="btn-rounded bg-afgreen text-white px-16" :href="brand.url" target="_blank">
                詳細はこちら
                <Icon type="arrow" class="fill-white"/>
              </a>
            </div>
          </li>
        </ul>
      </div>
      
    </div>
  </div>

</template>

